import { Action } from '@ngrx/store';
import { LineInterface } from '../../models/line.interface';

export enum ELineActions {
  GetLine = '[LINE] Get line',
  GetLineSuccess = '[LINE] Get line success',
  GetLineFailure = '[LINE] Get line failure',
  SetSelectedLine = '[LINE] Set selected line',
}

export class GetLine implements Action {
  public readonly type = ELineActions.GetLine;
  constructor(public phoneNumber: string) {}
}

export class GetLineSuccess implements Action {
  public readonly type = ELineActions.GetLineSuccess;
  constructor(public payload: LineInterface) {}
}

export class GetLineFailure implements Action {
  public readonly type = ELineActions.GetLineFailure;
}

export class SetSelectedLine implements Action {
  public readonly type = ELineActions.SetSelectedLine;
  constructor(public payload?: LineInterface) {}
}

export type LineActions = GetLine | GetLineSuccess | GetLineFailure | SetSelectedLine;
